(() => {
  'use strict';
  const $ = window.jQuery;
  if (!$) return;
  let returnFocus = null;
  let refreshTimer;
  const closeProductOverlays = () => {
    const quickShop = document.getElementById('mv-quick-shop');
    if (quickShop?.open) quickShop.close();
    document.documentElement.classList.remove('mv-dialog-open');
    $('[data-quickview]').removeClass('show show-content transition');
    if ($('body').hasClass('giftcard-active')) $('[data-gift-card-close]').first().trigger('click');
    $('.js-cart-modal').remove();
    document.querySelectorAll('.mv-quick-toast').forEach(el => el.hidden = true);
  };
  window.MVCart = {
    afterAdd() {
      returnFocus = document.activeElement;
      closeProductOverlays();
      clearTimeout(refreshTimer);
      refreshTimer = setTimeout(() => window.ajaxCart.load(true), 0);
    }
  };
  $(document).on('ajaxSuccess.mvCart', (event, xhr, settings) => {
    let url;
    try { url = new URL(settings.url, location.origin); } catch { return; }
    if (url.origin === location.origin && /\/cart\/add(?:\.js)?\/?$/.test(url.pathname) &&
        (settings.type || 'GET').toUpperCase() === 'POST' && xhr.status >= 200 && xhr.status < 300) {
      window.MVCart.afterAdd();
    }
  });
  $('body').on('drawer.open.mvCart', () => {
    if (!returnFocus) returnFocus = document.activeElement;
    closeProductOverlays();
    setTimeout(() => document.querySelector('.js-drawer .js-drawer-close')?.focus(), 30);
  }).on('drawer.close.mvCart', () => {
    if (returnFocus?.isConnected && !returnFocus.closest('dialog:not([open]), [data-quickview]:not(.show)')) returnFocus.focus();
    else document.querySelector('.js-header-cart')?.focus();
    returnFocus = null;
  });
  document.addEventListener('keydown', event => {
    if (!document.body.classList.contains('drawer--open')) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      $('body').trigger('drawer.close');
    }
    if (event.key === 'Tab') {
      const items = [...document.querySelectorAll('.js-drawer a[href], .js-drawer button:not([disabled]), .js-drawer input:not([disabled]), .js-drawer select:not([disabled]), .js-drawer textarea:not([disabled])')].filter(el => el.getClientRects().length);
      const first = items[0], last = items[items.length - 1];
      if (!first) return;
      if (event.shiftKey && (document.activeElement === first || !document.activeElement.closest('.js-drawer'))) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && (document.activeElement === last || !document.activeElement.closest('.js-drawer'))) { event.preventDefault(); first.focus(); }
    }
  });
})();
